import http from '../../app-http'


const getDefaultState = () => {
  return {
    busyIndicators:{
      loading: false,
      processing: false,
      deleting: null,
      
    },
    items: [],
    settings: {
      mode: 'list',
      showDeleted: false
    }
  }
};

export const state = getDefaultState();

export const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState())
  },
  SET_SETTINGS(state, newValue) {
    state.settings = newValue;
  },
  SET_BUSY_INDICATORS(state, newValue) {
    state.busyIndicators = newValue;
  },
  SET_ITEMS(state, newValue) {
    state.items = newValue;
  }
}

export const getters = {
  loading(state) {
    return state.busyIndicators.loading;
  },
  processing(state) {
    return state.busyIndicators.processing;
  },
  deleting(state) {
    return state.busyIndicators.deleting;
  },
  items(state) {
    return state.items;
  },
  itemsOnlyAlive(state) {
    return state.items.filter(x => !x.deletedAt);
  },
  settings(state) {
    return state.settings
  }
}

export const actions = {
  createUser({ dispatch, commit, state }, { dto } = {}) {
    return new Promise( (resolve, reject) => {
      commit('SET_BUSY_INDICATORS', {...state.busyIndicators, processing: true });
      http.post(`users`, dto).then(()=>{
        commit('SET_BUSY_INDICATORS', {...state.busyIndicators, processing: false });
        dispatch('loadUsers');
        dispatch('userGroups/loadAll', null, { root: true });
        resolve();
      }).catch((error) => {
        commit('SET_BUSY_INDICATORS', {...state.busyIndicators, processing: false });
        reject(error);
      });
    });
  },
  updateUser({ dispatch, commit, state }, { id, dto } = {}) {
    return new Promise( (resolve, reject) => {
    
      commit('SET_BUSY_INDICATORS', {...state.busyIndicators, processing: true });
      http.put(`users/${id}`, dto).then(()=>{
        commit('SET_BUSY_INDICATORS', {...state.busyIndicators, processing: false });
        dispatch('loadUsers');
        dispatch('userGroups/loadAll', null, { root: true });
        resolve();
      }).catch((error) => {
        commit('SET_BUSY_INDICATORS', {...state.busyIndicators, processing: false });
        reject(error);
      });
    });
  },
  deleteUser({ dispatch, commit, state }, { id } = {}) {
    return new Promise( (resolve, reject) => {
      commit('SET_BUSY_INDICATORS', {...state.busyIndicators, deleting: id });
      http.delete(`users/${id}`).then(()=>{
        commit('SET_BUSY_INDICATORS', {...state.busyIndicators, deleting: null });
        dispatch('loadUsers');
        dispatch('userGroups/loadAll', null, { root: true });
        resolve();
      }).catch((error) => {
        commit('SET_BUSY_INDICATORS', {...state.busyIndicators, deleting: null });
        reject(error);
      });
    });
  },
  loadSettings({ commit, state }) {
    return new Promise( (resolve, reject) => {
      commit('SET_BUSY_INDICATORS', {...state.busyIndicators, loading: true });
      http.get(`user-storage/page-users`).then((response)=>{
        commit('SET_BUSY_INDICATORS', {...state.busyIndicators, loading: false });
        if(response.data) {
          commit('SET_SETTINGS', response.data);
        }
        resolve(response.data);
      }).catch((error) => {
        commit('SET_BUSY_INDICATORS', {...state.busyIndicators, loading: false });
        reject(error);
      });
    });
  },
  writeSettings({ commit },value) {
    return new Promise( (resolve, reject) => {
      commit('SET_SETTINGS', value);
      http.post(`user-storage/page-users`, value).then((response)=>{
        resolve(response.data);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  loadUser({ commit, state }, { id } = {}) {
    return new Promise( (resolve, reject) => {
      commit('SET_BUSY_INDICATORS', {...state.busyIndicators, loading: true });
      http.get(`users/${id}`).then((response)=>{
        commit('SET_BUSY_INDICATORS', {...state.busyIndicators, loading: false });
        resolve(response.data);
      }).catch((error) => {
        commit('SET_BUSY_INDICATORS', {...state.busyIndicators, loading: false });
        reject(error);
      });
    });
  },
  loadUserHistory({ commit, state }, { id } = {}) {
    return new Promise( (resolve, reject) => {
      commit('SET_BUSY_INDICATORS', {...state.busyIndicators, loading: true });
      http.get(`users/${id}/changes`).then((response)=>{
        commit('SET_BUSY_INDICATORS', {...state.busyIndicators, loading: false });
        resolve(response.data);
      }).catch((error) => {
        commit('SET_BUSY_INDICATORS', {...state.busyIndicators, loading: false });
        reject(error);
      });
    });
  },
  loadUsers({ commit, state }) {
    return new Promise( (resolve, reject) => {
      commit('SET_BUSY_INDICATORS', {...state.busyIndicators, loading: true });
      http.get(`users`, { params: { deleted: state.settings.showDeleted }}).then((response)=>{
        commit('SET_BUSY_INDICATORS', {...state.busyIndicators, loading: false });
        commit('SET_ITEMS', response.data);
        resolve(response.data);
      }).catch((error) => {
        commit('SET_BUSY_INDICATORS', {...state.busyIndicators, loading: false });
        reject(error);
      });
    });
  }
}
